import {useState} from 'react';
import View from './view';
import {NameInfoAccordionProps} from './model';

export const NameInfoAccordion = (props: NameInfoAccordionProps) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = () => {
    setExpanded(!expanded);
  };

  return View({
    ...props,
    expanded,
    onPress: handleChange,
  });
};
